import React from 'react';
import ModalPolityka from "./Modals/ModalPolityka"
import ModalZastrzezenia from "./Modals/ModalZastrzezenia"

// import IconTwitter from "../images/icon-twitter.png"
import IconFacebook from "../images/icon-facebook.png"
// import IconYoutube from "../images/icon-youtube.png"
import IconInstagram from "../images/icon-instagram.png"

const Footer = () => {

	const [modPolitykaShow, setModPolitykaShow] = React.useState(false);
	const [modZastrzezeniaShow, setModZastrzezeniaShow] = React.useState(false);



	return (
		<>
		<footer className="footer py-5">
			<div className="container text-center">
			<button className="button-blank" onClick={() => setModPolitykaShow(true)}>
				Polityka prywatności
			</button>
			<button className="button-blank" onClick={() => setModZastrzezeniaShow(true)}>
				Zastrzeżenia prawne
			</button>

			<br />

			<a
			href="https://www.facebook.com/orlendlaciebie/?locale=pl_PL"
			className="icon-link"
			target="_blank" rel="noreferrer"
			><img src={IconFacebook} alt="Facebook" />
			</a>
			<a
			href="https://www.instagram.com/orlendlaciebie/"
			className="icon-link"
			target="_blank" rel="noreferrer"
			><img src={IconInstagram} alt="Instagram" />
			</a>
			</div>
		</footer>

			<ModalPolityka show={modPolitykaShow} handleclose={() => setModPolitykaShow(false)} />
			<ModalZastrzezenia show={modZastrzezeniaShow} handleclose={() => setModZastrzezeniaShow(false)} />
		</>
	)
}

export default Footer
